import { forwardRef } from "react";
import { useReducedMotion } from "motion/react";
import * as m from "motion/react-m";
import { motionTokens } from "./tokens";
import { useLandingViewport } from "./useLandingMobile";

export const RuleReveal = forwardRef(function RuleReveal(
  {
    as = "div",
    children,
    delay = 0,
    duration = motionTokens.duration.quick,
    style,
    ...props
  },
  ref,
) {
  const shouldReduceMotion = useReducedMotion();
  const viewport = useLandingViewport();
  const StaticElement = as;

  if (shouldReduceMotion) {
    return <StaticElement ref={ref} style={style} {...props}>{children}</StaticElement>;
  }

  const MotionElement = m[as] || m.div;

  return (
    <MotionElement
      ref={ref}
      initial="hidden"
      whileInView="visible"
      viewport={{ amount: viewport.amount, margin: viewport.margin, once: true }}
      variants={{
        hidden: { opacity: 0, scaleX: 0 },
        visible: {
          opacity: 1,
          scaleX: 1,
          transition: {
            delay,
            duration,
            ease: motionTokens.easing.entrance,
          },
        },
      }}
      style={{ transformOrigin: "0% 50%", ...style }}
      {...props}
    >
      {children}
    </MotionElement>
  );
});
